import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CustomerTestimonials = ({ testimonials }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials?.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  const currentTestimonial = testimonials?.[currentIndex];

  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-xl p-8 border border-border">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-text-primary mb-2">
          What Our Customers Say
        </h2>
        <p className="text-text-secondary">
          Real feedback from satisfied customers who chose our services
        </p>
      </div>
      {/* Main Testimonial */}
      <div className="bg-white rounded-xl p-8 shadow-elevation-2 mb-6">
        <div className="flex items-center justify-center mb-6">
          <div className="flex space-x-1">
            {[...Array(5)]?.map((_, i) => (
              <Icon
                key={i}
                name="Star"
                size={20}
                color={i < currentTestimonial?.rating ? "var(--color-warning)" : "var(--color-border)"}
              />
            ))}
          </div>
        </div>
        
        <blockquote className="text-lg text-text-primary text-center leading-relaxed mb-6 italic">
          "{currentTestimonial?.content}"
        </blockquote>
        
        <div className="flex items-center justify-center space-x-4">
          <div className="w-16 h-16 rounded-full overflow-hidden bg-muted">
            <Image
              src={currentTestimonial?.avatar}
              alt={currentTestimonial?.name}
              className="w-full h-full object-cover"
            />
          </div>
          <div className="text-center">
            <h4 className="font-semibold text-text-primary">
              {currentTestimonial?.name}
            </h4>
            <p className="text-sm text-text-secondary">
              {currentTestimonial?.location}
            </p>
            <div className="flex items-center justify-center space-x-2 mt-1">
              <Icon name="CheckCircle" size={14} color="var(--color-success)" />
              <span className="text-xs text-success font-medium">Verified Customer</span>
            </div>
          </div>
        </div>
        
        {currentTestimonial?.serviceType && (
          <div className="mt-4 text-center">
            <span className="inline-block bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-medium">
              {currentTestimonial?.serviceType}
            </span>
          </div>
        )}
      </div>
      {/* Navigation */}
      <div className="flex items-center justify-between">
        <Button
          variant="outline"
          size="icon"
          onClick={prevTestimonial}
          disabled={testimonials?.length <= 1}
        >
          <Icon name="ChevronLeft" size={20} />
        </Button>
        
        <div className="flex space-x-2">
          {testimonials?.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2 h-2 rounded-full transition-all duration-200 ${
                index === currentIndex ? 'bg-primary w-6' : 'bg-border'
              }`}
            />
          ))}
        </div>
        
        <Button
          variant="outline"
          size="icon"
          onClick={nextTestimonial}
          disabled={testimonials?.length <= 1}
        >
          <Icon name="ChevronRight" size={20} />
        </Button>
      </div>
      {/* Stats */}
      <div className="grid grid-cols-3 gap-6 mt-8 pt-8 border-t border-border">
        <div className="text-center">
          <div className="text-2xl font-bold text-primary">4.9/5</div>
          <div className="text-sm text-text-secondary">Average Rating</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-primary">2,847</div>
          <div className="text-sm text-text-secondary">Total Reviews</div>
        </div>
        <div className="text-center">
          <div className="text-2xl font-bold text-primary">99.8%</div>
          <div className="text-sm text-text-secondary">Satisfaction Rate</div>
        </div>
      </div>
    </div>
  );
};

export default CustomerTestimonials;